import { NBSP, RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';

import { ITariff } from '~/src/entities/formattedTariff';
import { ITariffsResult } from '~/src/features/internet/generateTariffSummaryTableFAQ/utils/getTariffsForTable';

interface ITransformConstructorForSummaryTable {
    hasOfferContents: boolean,
    hasAdditionalProducts: boolean,
    constructors: ITariff[],
}

export const transformConstructorForSummaryTable = ({
    hasOfferContents,
    hasAdditionalProducts,
    constructors,
}: ITransformConstructorForSummaryTable): ITariffsResult | null => {
    if (constructors.length === 0) {
        return null;
    }

    const cheapestConstructor = constructors.sort((a, b) => a.price - b.price)[0];

    return {
        channels: `На${NBSP}выбор, если каналы нужны`,
        url: '/constructor',
        buttonText: 'Собрать тариф',
        title: cheapestConstructor.title,
        price: `от${NBSP}${cheapestConstructor.price}${NBSP}${RubleSymbol}/мес`,
        speed: `от${NBSP}200${NBSP}Мбит/с`,
        salePackageId: cheapestConstructor.salePackageId.toString(),
        offerContents: hasOfferContents ? `На${NBSP}выбор, если подписки нужны` : undefined,
        additionalProducts: hasAdditionalProducts ? `На${NBSP}выбор, если оборудование нужно` : undefined,
    };
};
